<script>
const BANKS = {
  BBL: ['ธนาคารกรุงเทพ', 'bankokbank'], KBANK: ['ธนาคารกสิกรไทย', 'kbank'],
  KTB: ['ธนาคารกรุงไทย', 'ktb'], TTB: ['ธนาคารทหารไทยธนชาต', 'ttb'],
  SCB: ['ธนาคารไทยพาณิชย์', 'scb'], SCBT: ['ธนาคารสแตนดาร์ดชาร์เตอร์ด', 'standard'],
  CIMB: ['ธนาคารซีไอเอ็มบี ไทย', 'cimb'], UOB: ['ธนาคารยูโอบี', 'uob'],
  BAY: ['ธนาคารกรุงศรีอยุธยา', 'krungsri'], GSB: ['ธนาคารออมสิน', 'gsb'],
  GHB: ['ธนาคารอาคารสงเคราะห์', 'ghbank'], BAAC: ['ธ.ก.ส.', 'baac'],
  IBANK: ['ธนาคารอิสลามแห่งประเทศไทย', 'ธนาคารอิสลาม'], TISCO: ['ธนาคารทิสโก้', 'tisco'],
  KKP: ['ธนาคารเกียรตินาคินภัทร', 'kiatnakin'], ICBC: ['ธนาคารไอซีบีซี (ไทย)', 'icbc'],
  TCRB: ['ธนาคารไทยเครดิต', null], LHBANK: ['ธนาคารแลนด์ แอนด์ เฮ้าส์', 'lh'],
}

export default {
  name: 'Adminpay24DepositDetails',
  props: {
    deposit: { type: Object, default: null },
    busy: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  data() { return { copied: false, copyError: '' } },
  computed: {
    account() { return this.deposit && this.deposit.receivingAccount },
    isBankTransfer() { return this.account && this.account.type === 'BANK' },
    bank() { return this.account && BANKS[this.account.bankCode] },
    bankName() { return this.account && ((this.bank && this.bank[0]) || this.account.bankName || this.account.bankCode) },
    bankLogo() { return this.bank && this.bank[1] ? require(`@/assets/images/bank/${this.bank[1]}.jpg`) : null },
    terminal() { return this.deposit && ['EXPIRED', 'CANCELLED', 'REFUNDED'].includes(this.deposit.status) },
    canPay() { return this.deposit && !this.terminal && this.deposit.status !== 'PAID' },
    checkoutUrl() {
      const url = this.deposit && this.deposit.checkoutUrl
      return typeof url === 'string' && /^https:\/\/adminpay24\.com\/c\.html\?id=[a-f0-9]{32}$/.test(url) ? url : ''
    },
    canAttachSlip() { return this.checkoutUrl && (this.canPay || this.deposit.status === 'EXPIRED') },
    copyLabel() { return this.copied ? 'คัดลอกแล้ว' : (this.isBankTransfer ? 'คัดลอกเลขบัญชี' : 'คัดลอกหมายเลขพร้อมเพย์') },
    formattedAmount() {
      return this.deposit ? Number(this.deposit.amount).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
    },
    expiry() {
      const value = this.deposit && this.deposit.expiresAt
      return value && Number.isFinite(Date.parse(value)) ? new Date(value).toLocaleString('th-TH', {
        day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
      }) : ''
    },
  },
  watch: {
    'deposit.id'() { this.copied = false; this.copyError = '' },
  },
  methods: {
    copySuccess() { this.copied = true; this.copyError = '' },
    copyFailure() { this.copied = false; this.copyError = 'คัดลอกไม่สำเร็จ กรุณาคัดลอกหมายเลขด้านบน' },
  },
}
</script>

<template>
  <section class="ap24" aria-label="รายละเอียดการฝาก adminpay24">
    <header class="ap24-header">
      <span class="ap24-brand">adminpay<span>24</span></span>
      <span v-if="canPay" class="ap24-status"><i aria-hidden="true" />รอรับยอดโอน</span>
    </header>

    <div v-if="busy && !deposit" class="ap24-state" role="status">
      <span class="ap24-spinner" aria-hidden="true" />
      <p>กำลังเตรียมรายการฝากเงิน</p>
      <span>รอสักครู่ ระบบกำลังเรียกข้อมูลบัญชี</span>
    </div>

    <template v-if="deposit">
      <div class="ap24-amount">
        <p>ยอดที่ต้องโอน</p>
        <div><strong>{{ formattedAmount }}</strong><span>บาท</span></div>
      </div>

      <div v-if="account && canPay" class="ap24-account-card">
        <div class="ap24-bank">
          <img v-if="isBankTransfer && bankLogo" :src="bankLogo" class="ap24-bank-logo" alt="">
          <span v-else class="ap24-bank-symbol" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m3 9 9-6 9 6H3ZM5 11v7m7-7v7m7-7v7M3 21h18M3 18h18" /></svg>
          </span>
          <div><span class="ap24-caption">{{ isBankTransfer ? 'บัญชีสำหรับโอนเงิน' : 'ชำระผ่านพร้อมเพย์' }}</span><p>{{ isBankTransfer ? bankName : 'PromptPay' }}</p></div>
        </div>
        <img v-if="deposit.qrCode && !isBankTransfer" :src="deposit.qrCode" class="ap24-qr" alt="QR Code สำหรับฝากผ่าน adminpay24">
        <dl class="ap24-account-info">
          <div><dt>{{ isBankTransfer ? 'เลขบัญชี' : 'หมายเลขพร้อมเพย์' }}</dt><dd class="ap24-account-number">{{ account.accountNumber }}</dd></div>
          <div v-if="account.accountName" class="ap24-account-holder"><dt>ชื่อบัญชี</dt><dd>{{ account.accountName }}</dd></div>
        </dl>
        <button type="button" class="ap24-copy" :class="{ 'is-copied': copied }" :aria-label="copyLabel"
          v-clipboard:copy="account.accountNumber" v-clipboard:success="copySuccess" v-clipboard:error="copyFailure">
          <svg v-if="copied" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m5 12 4 4L19 6" /></svg>
          <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="8" y="8" width="12" height="13" rx="2" /><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" /></svg>
          <span role="status">{{ copyLabel }}</span>
        </button>
        <p v-if="copyError" class="ap24-copy-error" role="alert">{{ copyError }}</p>
      </div>
      <img v-else-if="deposit.qrCode && !isBankTransfer && canPay" :src="deposit.qrCode" class="ap24-qr ap24-qr-standalone" alt="QR Code สำหรับฝากผ่าน adminpay24">

      <div v-if="canPay" class="ap24-notice">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 11v6m0-10v1" /></svg>
        <p>โอนยอดให้ตรงตามที่แสดง <strong>รวมสตางค์</strong><br>จากบัญชีที่ลงทะเบียนเท่านั้น</p>
      </div>
      <p v-if="expiry && canPay" class="ap24-expiry">โอนก่อน <time :datetime="deposit.expiresAt">{{ expiry }}</time></p>
      <div v-if="terminal" class="ap24-state ap24-state-ended" role="status">
        <p>{{ deposit.status === 'EXPIRED' ? 'รายการฝากหมดอายุแล้ว' : 'รายการฝากสิ้นสุดแล้ว' }}</p>
        <span v-if="deposit.status === 'EXPIRED' && canAttachSlip">ยังไม่ได้โอน ให้สร้างรายการใหม่<br>หากโอนก่อนหมดเวลาแล้ว ให้แนบสลิปของรายการนี้</span>
        <span v-else>กรุณาสร้างรายการใหม่เพื่อรับข้อมูลสำหรับโอนเงิน</span>
      </div>
      <div v-if="deposit.status === 'PAID'" class="ap24-state" role="status">
        <p>รับชำระเงินแล้ว</p><span>ระบบกำลังตรวจสอบและเติมเครดิตให้คุณ</span>
      </div>
      <div v-if="canAttachSlip" class="ap24-slip">
        <p class="ap24-slip-title">{{ deposit.status === 'EXPIRED' ? 'โอนแล้ว แนบสลิปของรายการเดิม' : 'โอนแล้ว แนบสลิปเพื่อยืนยัน' }}</p>
        <p class="ap24-slip-help">{{ deposit.status === 'EXPIRED' ? 'Adminpay จะตรวจสอบรายการที่โอนก่อนหมดเวลา' : 'แนบสลิปที่หน้า Adminpay เมื่อยืนยันสำเร็จ ระบบจะเติมเครดิตให้คุณ' }}</p>
        <a :href="checkoutUrl" target="_blank" rel="noopener noreferrer" referrerpolicy="no-referrer"
          class="ap24-copy ap24-slip-button" @click.stop="$emit('attach-slip')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Z" /><path d="M14 3v6h6M8 15h8m-8 3h5" /></svg>
          โอนแล้ว แนบสลิป
        </a>
        <span class="ap24-slip-return">เปิดหน้า Adminpay ในแท็บใหม่ แล้วกลับมาตรวจสอบยอดที่หน้านี้</span>
      </div>
    </template>

    <p v-if="error" class="ap24-error" role="alert">{{ error }}</p>
    <div class="ap24-actions">
      <button v-if="error || (deposit && (!terminal || canAttachSlip))" type="button" class="ap24-check" :disabled="busy" @click="$emit('check')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M20 7v5h-5M4 17v-5h5M19 12a7 7 0 0 0-12-5L4 10m16 4-3 3a7 7 0 0 1-12-5" /></svg>
        {{ busy ? 'กำลังตรวจสอบ…' : 'ตรวจสอบสถานะการฝาก' }}
      </button>
      <button v-if="terminal" type="button" class="ap24-copy" @click="$emit('restart')">สร้างรายการใหม่</button>
    </div>
  </section>
</template>

<style scoped>
.ap24 { --gold: #edce81; --muted: #aab7cd; width: 100%; max-width: 390px; margin: 0 auto; padding: 14px 16px 4px; color: #f7f7fa; text-align: left; }
.ap24 p, .ap24 dl, .ap24 dd { margin: 0; }
.ap24-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding-bottom: 16px; border-bottom: 1px solid rgba(237, 206, 129, .18); }
.ap24-brand { font-size: 17px; letter-spacing: -.4px; font-weight: 500; }
.ap24-brand > span { color: var(--gold); }
.ap24-status { display: inline-flex; align-items: center; gap: 6px; font-size: 11px; color: var(--gold); padding: 5px 9px; border: 1px solid rgba(237, 206, 129, .24); border-radius: 24px; }
.ap24-status i { width: 5px; height: 5px; background: var(--gold); border-radius: 50%; }
.ap24-amount { text-align: center; padding: 19px 0 20px; }
.ap24-amount > p { font-size: 13px; color: var(--muted); }
.ap24-amount > div { display: flex; align-items: baseline; justify-content: center; gap: 9px; margin-top: 2px; }
.ap24-amount strong { color: var(--gold); font-size: 44px; line-height: 1.2; font-weight: 500; font-variant-numeric: tabular-nums; letter-spacing: -1px; }
.ap24-amount > div > span { font-size: 15px; color: var(--gold); }
.ap24-account-card { padding: 20px; border-radius: 16px; color: #1c2940; background: #f6f3eb; box-shadow: 0 10px 30px rgba(0, 0, 0, .14); }
.ap24-bank { display: flex; align-items: center; gap: 12px; padding-bottom: 16px; border-bottom: 1px solid #dcdedc; }
.ap24-bank-logo, .ap24-bank-symbol { width: 44px; height: 44px; border-radius: 11px; flex-shrink: 0; object-fit: cover; }
.ap24-bank-symbol { display: grid; place-items: center; background: #e9e4d7; }
.ap24-bank-symbol svg { width: 26px; height: 26px; }
.ap24-caption, .ap24-account-info dt { font-size: 11px; font-weight: 400; color: #657184; }
.ap24-bank p { font-size: 16px; line-height: 1.5; font-weight: 500; }
.ap24-account-info { padding: 15px 0 17px; }
.ap24-account-number { font-size: 29px; letter-spacing: 1px; line-height: 1.5; font-weight: 500; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; user-select: all; }
.ap24-account-holder { margin-top: 8px; }
.ap24-account-holder dd { font-size: 15px; line-height: 1.5; overflow-wrap: anywhere; }
.ap24-copy { display: flex; justify-content: center; align-items: center; gap: 9px; width: 100%; min-height: 44px; padding: 10px 14px; border: 1px solid #dfbf6e; border-radius: 9px; background: #edce81; color: #1c2940; font: inherit; font-size: 14px; font-weight: 500; cursor: pointer; transition: background .15s, transform .15s; }
.ap24-copy:hover { background: #f4db9c; }
.ap24-copy:active { transform: translateY(1px); }
.ap24-copy.is-copied { background: #dfecdf; border-color: #b4d0b5; color: #245e37; }
.ap24-copy svg, .ap24-check svg { width: 18px; height: 18px; flex-shrink: 0; }
.ap24-copy:focus-visible, .ap24-check:focus-visible { outline: 2px solid #fff; outline-offset: 3px; box-shadow: 0 0 0 4px #1c2940; }
.ap24-notice { display: flex; align-items: flex-start; gap: 9px; padding: 16px 2px 0; color: var(--muted); }
.ap24-notice svg { width: 17px; height: 17px; margin-top: 3px; flex-shrink: 0; color: var(--gold); }
.ap24-notice p { font-size: 12px; line-height: 1.7; }
.ap24-notice strong { color: var(--gold); font-weight: 400; }
.ap24-expiry { padding: 10px 0 0; font-size: 11px; color: var(--muted); text-align: center; }
.ap24-expiry time { color: #e0e6ef; }
.ap24-slip { margin-top: 16px; padding: 16px; border: 1px solid rgba(237, 206, 129, .28); border-radius: 12px; background: rgba(237, 206, 129, .05); }
.ap24-slip-title { font-size: 14px; font-weight: 500; color: var(--gold); }
.ap24-slip-help { padding-top: 6px; color: #d3dced; font-size: 12px; line-height: 1.7; }
.ap24-slip-button { margin-top: 13px; text-decoration: none; }
.ap24-slip-button:hover { color: #1c2940; text-decoration: none; }
.ap24-slip-return { display: block; padding-top: 9px; color: var(--muted); font-size: 11px; line-height: 1.6; text-align: center; }
.ap24-actions { display: flex; flex-direction: column; align-items: center; padding-top: 10px; }
.ap24-check { display: flex; align-items: center; justify-content: center; gap: 7px; background: transparent; color: #c9d4e7; border: 0; padding: 10px; font: inherit; font-size: 12px; cursor: pointer; }
.ap24-check:hover { color: var(--gold); }
.ap24-check:disabled { opacity: .55; cursor: wait; }
.ap24-state { padding: 35px 10px; text-align: center; }
.ap24-state p { font-size: 17px; color: var(--gold); margin-bottom: 7px; }
.ap24-state > span:not(.ap24-spinner) { font-size: 13px; color: var(--muted); }
.ap24-state-ended { padding: 18px 8px; }
.ap24-spinner { display: block; width: 28px; height: 28px; margin: 0 auto 16px; border: 2px solid rgba(237, 206, 129, .2); border-top-color: var(--gold); border-radius: 50%; animation: ap24-spin 1s linear infinite; }
.ap24-qr { display: block; width: 224px; max-width: 100%; margin: 16px auto 0; padding: 8px; background: #fff; border-radius: 8px; }
.ap24-qr-standalone { margin-top: 0; }
.ap24-error, .ap24-copy-error { padding-top: 12px; font-size: 12px; color: #ff9e9e; overflow-wrap: anywhere; text-align: center; }
.ap24-copy-error { color: #a53030; }
@keyframes ap24-spin { to { transform: rotate(360deg); } }
@media (max-width: 380px) { .ap24 { padding-right: 10px; padding-left: 10px; } .ap24-account-card { padding: 16px; } .ap24-account-number { font-size: 25px; letter-spacing: .7px; } .ap24-amount strong { font-size: 38px; } }
@media (prefers-reduced-motion: reduce) { .ap24-spinner { animation: none; } .ap24-copy { transition: none; } }
</style>
